import { Spinner } from "../../../../Feedback";

import styles from "./MonthSpinner.module.scss";

export function MonthSpinner() {
    return (
        <div className={styles["month-spinner"]}>
            <Spinner size={64} thickness={2} />
        </div>
    );
}
